module.exports = __webpack_public_path__ + "static/media/EditProfile.66b1f693.svg";